import React from "react";
import { useTranslation } from 'react-i18next';

const TermsAndConditions = () => {
  const { t } = useTranslation();

  return (
    <section id="terms">
        <div style={{paddingTop: '5em'}} className="row">
          <div className="three columns">
          </div>
          <div className="twelve columns main-col">
            <h2>{t('terms.title')}</h2>
            <p>
              {t('terms.intro')}
            </p>
            <p>{t('terms.userDeclaration')}</p>
            <p>
              {t('terms.readUnderstoodAccept')}
            </p>
            <p>{t('terms.assumeObligations')}</p>
            <p>{t('terms.ageRequirement')}</p>
            <p>{t('terms.acceptanceModification')}</p>
            <p>{t('terms.notificationChanges')}</p>
            <p>{t('terms.acceptanceModified')}</p>

            <h3>{t('terms.registrationRequirement')}</h3>
            <p>
              {t('terms.registrationProcedure')}
            </p>
            <p>
              {t('terms.userDataAccuracy')}
            </p>
            <p>
              {t('terms.passwordSecurity')}
            </p>
            <p>
              {t('terms.unauthorizedUse')}
            </p>
            <p>
              {t('terms.accountAccessResponsibility')}
            </p>
            <p>
              {t('terms.dataProcessingConsent')}
            </p>

            <h3>{t('terms.usageRules')}</h3>
            <p>
              {t('terms.lawMoralityCompliance')}
            </p>
            <p>
              {t('terms.appropriateUse')}
            </p>
            <p>
              {t('terms.noTransmissionProhibitedContent')}
            </p>
            <p>
              {t('terms.noIllegalContentTransmission')}
            </p>
            <p>
              {t('terms.noUnsolicitedAdvertising')}
            </p>
            <p>
              {t('terms.noFalseInformation')}
            </p>
            <p>
              {t('terms.noImpersonation')}
            </p>
            <p>
              {t('terms.noUnauthorizedContentSharing')}
            </p>
            <p>
              {t('terms.noMinorsRepresentation')}
            </p>
            <p>
              {t('terms.noSafetyEndangeringChallenges')}
            </p>
            <p>
              {t('terms.noFalseChallenges')}
            </p>
            <p>
              {t('terms.noReputationDamageActivities')}
            </p>
            <p>
              {t('terms.correctServiceUse')}
            </p>
            <p>
              {t('terms.indemnification')}
            </p>

            <h3>{t('terms.userExclusion')}</h3>
            <p>
              {t('terms.userExclusionReserve')}
            </p>
            <p>
              {t('terms.improvementExclusion')}
            </p>

            <h3>{t('terms.disclaimer')}</h3>
            <p>
              {t('terms.challengeOwnershipDisclaimer')}
            </p>
            <p>
              {t('terms.disclaimerExamples')}
            </p>
            <p>
              {t('terms.userServiceUse')}
            </p>
            <p>
              {t('terms.userContentDisclaimer')}
            </p>
            <p>
              {t('terms.serviceMaterialUse')}
            </p>
            <p>
              {t('terms.unfairCompetitionDisclaimer')}
            </p>
            <p>
              {t('terms.userDataLossDisclaimer')}
            </p>
            <p>
              {t('terms.minorAccessDisclaimer')}
            </p>
            <p>
              {t('terms.serviceAvailabilityDisclaimer')}
            </p>
            <p>
              {t('terms.communicationFailuresDisclaimer')}
            </p>
            <p>
              {t('terms.emailOperationalProblemsDisclaimer')}
            </p>
            <p>
              {t('terms.userServiceResponsibility')}
            </p>
            <p>
              {t('terms.userDisputeResolution')}
            </p>

            <h3>{t('terms.linkedContentServices')}</h3>
            <p>
              {t('terms.linkedServicesDisclaimer')}
            </p>
            <p>
              {t('terms.linkedSitesResponsibility')}
            </p>
            <p>
              {t('terms.linkedSitesAvailabilityDisclaimer')}
            </p>
            <p>
              {t('terms.linkedSitesResponsibilityLimitation')}
            </p>
            <p>
              {t('terms.linkedSitesNoticeProcedure')}
            </p>
            <p>
              {t('terms.linkedSitesNonEndorsement')}
            </p>
            <p>
              {t('terms.linkedSitesContentResponsibility')}
            </p>

            <h3>{t('terms.intellectualProperty')}</h3>
            <p>
              {t('terms.serviceContentOwnership')}
            </p>
            <p>
              {t('terms.noIPorLicenseAcquisition')}
            </p>
            <p>
              {t('terms.serviceContentDescription')}
            </p>
            <p>
              {t('terms.userContentOwnership')}
            </p>
            <p>
              {t('terms.contentUsageRightsTransfer')}
            </p>
            <p>
              {t('terms.noEndorsement')}
            </p>

            <h3>{t('terms.subscriptionService')}</h3>
            <p>
              {t('terms.subscriptionDescription')}
            </p>
            <p>
              {t('terms.paidSubscriptions')}
            </p>
            <p>
              {t('terms.subscriptionRenewal')}
            </p>
            <p>
              {t('terms.subscriptionChanges')}
            </p>
            <p>
              {t('terms.subscriptionCancellation')}
            </p>

            <h3>{t('terms.premiumFeatures')}</h3>
            <p>
              {t('terms.premiumFeaturesDescription')}
            </p>
            <p>
              {t('terms.premiumFeatureAvailability')}
            </p>
            <p>
              {t('terms.premiumFeatureChanges')}
            </p>
            <p>
              {t('terms.premiumFeaturePayments')}
            </p>

            <h3>{t('terms.personalDataProtection')}</h3>
            <p>
              {t('terms.dataProtectionDescription')}
            </p>
            <p>
              {t('terms.userConsent')}
            </p>

            <h3>{t('terms.termination')}</h3>
            <p>
              {t('terms.serviceTermination')}
            </p>
            <p>
              {t('terms.noUserCompensation')}
            </p>

            <h3>{t('terms.acceptanceGeneralConditions')}</h3>
            <p>
              {t('terms.acceptanceContinuedUse')}
            </p>
            <p>
              {t('terms.acceptanceLegalAgreement')}
            </p>
            <p>
              {t('terms.acceptanceElectronicConsent')}
            </p>
            <p>
              {t('terms.acceptanceLanguage')}
            </p>
          </div>
        </div>
    </section>
  );
};

export default TermsAndConditions;
